<template>
  <div id="page_app">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">Add Image Slider</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout fluid row wrap>
              <v-flex lg6 sm6 xs12>
                <v-text-field label="Title" name="name" v-model="adddata.name"></v-text-field>
              </v-flex>
              <v-flex lg6 sm12 xs12>
                <v-text-field label="Target Url (Optional)" name="image" v-model="adddata.url"></v-text-field>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-text-field label="Image" name="image" v-model="adddata.image"></v-text-field>
              </v-flex>

              <v-flex lg12 sm12 xs12>
                <v-img class="grey lighten-2 pa-110 imgslide" :src="adddata.image" aspect-ratio="1"></v-img>
              </v-flex>
              <v-flex lg6 sm12 xs12>
                <v-text-field label="Status" name="order" v-model="adddata.status"></v-text-field>
              </v-flex>
              <v-flex lg6 sm12 xs12>
                <v-text-field
                  class="padding-left"
                  label="Sort Order"
                  name="order"
                  type="number"
                  v-model="adddata.order"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeform()">Cancel</v-btn>
          <v-btn color="success" @click="simpanForm(adddata)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn color="primary" @click.native="getNews()">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="list"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                select-all
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ props.item.kode }}</td>
                  <td class="text-xs-left">{{ props.item.nama }}</td>
                  <td class="text-xs-left">{{ props.item.alamat }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.kode_upline }}</td>
                  <td class="text-xs-left">{{ formatNumber(props.item.saldo) }}</td>
                  <td class="text-xs-left">{{ formatDate(props.item.tgl_daftar) }}</td>
                  <td class="text-xs-left">{{ formatDate(props.item.updateAt) }}</td>
                  <td class="text-xs-left">
                    <v-btn
                      @click.native="OpenFormEdit(props.item)"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      @click.native="deleteItem(props.item)"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="pink"
                      small
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
  components: {},
  data: () => ({
    state_add: false,
    search: '',
    selected_combo: '',
    applist: [{ text: 'BeliStok', value: 1 }, { text: 'WartoMAx', value: 2 }],
    editorOption: {},
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: 'Kode Agen',
          value: 'kode'
        },
        {
          text: 'Nama Agen',
          value: 'nama'
        },
        {
          text: 'Alamat',
          value: 'alamat'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Referal',
          value: 'kode_upline'
        },
        {
          text: 'Saldo',
          value: 'saldo'
        },
        {
          text: 'Register Date',
          value: 'tgl_data'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      items: []
    },
    delete_id: '',
    adddata: {
      appid: '',
      name: '',
      order: 1,
      status: 1,
      url: 'https',
      image: ''
    }
  }),
  created () {
    // this.getApplist();
  },
  mounted () {
    this.getNews()
  },
  computed: {
    ...mapState('Reseller', ['list', 'dialog', 'loading'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      AddNew: 'Reseller/Add',
      closeDialog: 'Reseller/closeDialog',
      OpenDialogForm: 'Reseller/OpenDialogForm',
      getNews: 'Reseller/list',
      delete_news: 'Reseller/Delete'
    }),
    closeform () {
      this.adddata.name = ''
      this.adddata.image = ''
      this.adddata.url = ''
      this.adddata.appid = ''
      this.closeDialog()
      this.state_add = false
      this.getNews()
    },
    OpenFormEdit (data) {
      this.adddata = data
      this.state_add = false
      this.OpenDialogForm()
    },
    openmodal () {
      this.state_add = true
      this.OpenDialogForm()
    },
    simpanForm (data) {
      if (this.state_add) {
        this.AddNew(data)
      } else {
        this.AddNew(data)
      }
      this.state_add = false
      this.adddata.name = ''
      this.adddata.image = ''
      this.adddata.url = ''
      this.adddata.appid = ''
      this.getNews()
    },
    deleteItem (data) {
      this.delete_id = data.id
      if (confirm('Are you sure you want delete ?')) {
        this.delete_news(this.delete_id)
        this.getNews()
      }
    },
    formatNumber (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return val.replace(',00', '')
    },
    formatDate (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style lang="stylus" scoped>
.quill {
  height: 300px;
  padding-bottom: 95px;
}

.tdlist {
  padding: 10px !important;
}

.padding-left {
  padding-left: 10px !important;
}

.imgslide {
  width: 100%;
  height: 200px;
}

.imgslidelist {
  width: 300px;
  height: 100px;
}
</style>
